// Modules
import { Component, Inject, ViewChild } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { SelectComponent } from 'ng2-select';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
// Components
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
// Model
import { NgSelectOptionModel } from '../../../../shared/model/ng-select-option.model';
// Services
import {
  UIActiveDialogService,
  UIDialogService
} from '../../../../shared/services/ui-dialog.service';
// Utils
import { SortUtils } from '../../../../shared/utils/sort.utils';
import { ProductService } from '../../../product/service/product.service';
import { AuthService } from '../../../security/service/auth.service';
import { AssetService } from '../../service/asset.service';
import { AssetUIMessages } from '../model/asset-ui.messages';
import { SiteModel } from '../model/site.mode';

@Component({
  selector: 'site-selector-dialog',
  templateUrl:
    './console/app-js/modules/asset/components/site-selector/site-selector-dialog.component.html'
})
export class SiteSelectorDialogComponent extends APIOperableComponent {
  @ViewChild('customerSelect', { static: true })
  protected customerSelect: SelectComponent;
  protected allSites: Array<any> = [];
  protected siteSelected: Array<any> = [];
  protected selectedCustomerId: string = '';
  protected allCustomers: Array<{ id: string; text: string }> = [];
  private originalData;
  protected filterValue = '';
  private loadingSites = false;
  private selectedCustomer: NgSelectOptionModel;
  constructor(
    @Inject('site') site: any,
    @Inject('selectedCustomer') selectedCustomer: any,
    private activeDialog: UIActiveDialogService,
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private assetService: AssetService,
    protected productService: ProductService,
    protected dialogService: UIDialogService
  ) {
    super(progressService, toastr, authService);
    this.selectedCustomer = selectedCustomer;
    this.onLoad(site);
  }

  /**
   * Load all lists from API for the view.
   * @param {any} site
   */
  private onLoad(site): void {
    this.loadAllCustomers();
    this.siteSelected.push({ ...site });
  }

  /**
   * Loads a list of customers
   * @returns {Observable<any>}
   */
  protected loadAllCustomers() {
    this.loadingIndicator = true;
    this.assetService.getCustomers().subscribe(
      (res: any) => {
        if (res) {
          let customers = res.map(customer => {
            return {
              id: customer.number,
              text: `${customer.name} (${customer.number})`
            };
          });
          this.allCustomers = customers.sort((a, b) =>
            SortUtils.compareByProperty(a, b, 'text')
          );
          if (this.allCustomers && this.allCustomers.length > 0) {
            this.customerSelect.active = this.selectedCustomer
              ? [this.selectedCustomer]
              : [this.allCustomers[0]];
            this.loadingIndicator = false;
            this.selectedCustomerId = this.customerSelect.active[0].id;
          }
        }
      },
      () => this.onAPIError(AssetUIMessages.LOAD_CUSTOMERS_ERROR)
    );
  }

  /**
   * Sets the sites to the select field.
   * @param {string} customerId
   * @returns {Observable<any>}
   */
  protected loadSites(customerId: string, params?: any) {
    this.startProgress();
    this.loadingSites = true;
    this.originalData = null;
    this.allSites = [];
    this.assetService.getSites(customerId, params).subscribe(
      (res: Array<SiteModel>) => {
        if (res) {
          this.allSites = res;
          this.selectSite();
        }
        this.loadingSites = false;
        this.finishProgress();
      },
      error => {
        console.error(error);
        this.onAPIError(AssetUIMessages.LOAD_SITES_ERROR);
      }
    );
  }

  /**
   * Search for a site on the current data and adds it to the current site selection.
   */
  private selectSite(): void {
    if (this.siteSelected[0] && this.siteSelected[0].id) {
      const match = this.allSites.find(
        item => item.id === this.siteSelected[0].id
      );
      if (match) {
        this.siteSelected = [];
        this.siteSelected.push(match);
      }
    }
  }

  /**
   * Returns the selected data and closes the current active dialog.
   */
  onAddItem(): void {
    this.activeDialog.close({
      site: this.siteSelected[0],
      customer: this.customerSelect.active[0]
    });
  }

  /**
   * On Cancel/Close button event.
   */
  protected onCancelClose(): void {
    this.activeDialog.dismiss();
  }

  /**
   * Gets a Site by id from the current list of Sites previously loaded.
   * @param {number} siteId
   * @returns {MakeModel}
   */
  protected getSite(siteId: number): Array<any> {
    return this.allSites.find(item => item.id === siteId);
  }

  /**
   * On Customer selected option
   * @param {NgSelectOptionModel} $event
   */
  protected onCustomerSelected($event: NgSelectOptionModel): void {
    this.selectedCustomerId = $event.id;
    this.onClearFilter();
  }

  /**
   * On Customer removed option
   */
  protected onCustomerRemoved(): void {
    this.loadSites(this.allCustomers[0].id);
  }

  /**
   * Clear the input filter.
   */
  private onClearFilter(): void {
    this.filterValue = '';
    this.onFilterData();
  }

  /**
   * Executes filter when user type some value.
   */
  protected onFilterData(): void {
    if (this.filterValue && this.filterValue.length >= 3) {
      const params = {
        filterValue: this.filterValue
      };
      this.loadSites(this.selectedCustomerId, params);
      if (!this.originalData) {
        this.originalData = [...this.allSites];
      }
      let value = this.filterValue.toLocaleLowerCase();
      // filter our data
      const temp = this.originalData.filter(r => {
        return r.name.toLowerCase().indexOf(value) !== -1 || !value;
      });
      // update the rows
      this.allSites = temp;
    } else {
      this.allSites = [];
    }
  }
}
